import { isObject } from '../../../utils/object';
export const DASH_FORMAT = '—';
export function defaultNumberFormat(value, fractionDigits = 0) {
    const strValue = value
        ? value.toLocaleString('en-US', { maximumFractionDigits: fractionDigits })
        : DASH_FORMAT;
    const decimalPart = strValue.split('.')[1];
    return decimalPart && decimalPart.length < 2 ? `${strValue}0` : strValue;
}
export const getCellValue = (value) => isObject(value) ? value === null || value === void 0 ? void 0 : value.value : value;
//# sourceMappingURL=index.js.map